import React, { Suspense } from 'react';
import CreateContainer from "./CreateContainer";

const CreateEvaluation = (props) => {
    return (
        <CreateContainer {...props} />
    );
};

export default CreateEvaluation;